import { Component, OnDestroy, OnInit } from "@angular/core";
import { CookieService } from "ngx-cookie-service";
import { Subscription } from "rxjs";
import { map } from "rxjs/operators";
import { ReportsWindowFacade } from "./facade/reports-window.facade";

export const REPORT_BUTTON_COOKIE = "show_reports_button_";

@Component({
  selector: "app-reports-window",
  templateUrl: "./reports-window.component.html",
  styleUrls: ["./reports-window.component.scss"],
  providers: [CookieService],
})
export class ReportsWindowComponent implements OnInit, OnDestroy {
  constructor(private facade: ReportsWindowFacade, private cookieService: CookieService) {}

  private subscriptions: Subscription[] = [];

  open$ = this.facade.open$;
  reports$ = this.facade.reports$;
  retailer$ = this.facade.getRetailer$;
  showButton$ = this.facade.showButton$;

  toggleOpenWindow(b: boolean) {
    this.facade.setUi([{ name: "openReportsWindow", value: b }]);
  }

  refreshOrders() {
    this.facade.getReports();
  }

  ngOnInit(): void {
    const s = this.open$.subscribe(o => {
      if (o) {
        this.facade.getReports();
      }
    });
    const s2 = this.retailer$
      .pipe(
        map(r => {
          const open = this.cookieService.get(REPORT_BUTTON_COOKIE + r.id);
          if (open) {
            this.facade.setUi([{ name: "showReportsWindowButton", value: true }]);
          }
        })
      )
      .subscribe();

    this.subscriptions.push(s, s2);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s?.unsubscribe());
  }
}
